<template>
  <ModalDialog :closeable="true" :open.sync="IsOpen">
    <template v-if="lang === 'fr'">
      <img :src="require('/src/assets/meters/findSmartMeterLastDigits_fr.jpg')" />
      <img :src="require('/src/assets/meters/findMeterLastDigits_fr.png')" />
    </template>
    <template v-else-if="lang === 'nl'">
      <img :src="require('/src/assets/meters/findSmartMeterLastDigits_nl.jpg')" />
      <img :src="require('/src/assets/meters/findMeterLastDigits_nl.png')" />
    </template>
    <template v-else-if="lang === 'de'">
      <img :src="require('/src/assets/meters/findSmartMeterLastDigits_de.jpg')" />
      <img :src="require('/src/assets/meters/findMeterLastDigits_de.png')" />
    </template>
  </ModalDialog>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator'
import { State } from 'vuex-class'

@Component
export default class FindMeterLastDigitsModalDialog extends Vue {
  //#region [Property]
  @Prop({ type: Boolean, required: true })
  public readonly value!: boolean
  //#endregion

  //#region [Data]
  @State('lang')
  public lang!: string | null
  //#endregion

  //#region [Computed]
  public get IsOpen(): boolean {
    return this.value
  }

  public set IsOpen(val: boolean) {
    this.$emit('input', val)
  }
  //#endregion
}
</script>